// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3O5m3","alert":"SettungsInbox_alert__2y_LF"};